import React, { useReducer, useState, useRef, useContext,useEffect } from 'react';
import { Col, Form, message, Modal, Table, Tabs } from 'antd';
import {
  Checkbox,
  MobileTabBar,
  Button,
  Input,
  SelectFile,
  Layout,
  Footer,
  InfoBox,
} from 'components';
import classNames from 'classnames';

import ExportFileIcon from 'assests/icons/export-file.icon';
import GroupsIcon from 'assests/icons/groups.icon';
import DeleteIcon from 'assests/icons/delete.icon';
import EditIcon from 'assests/icons/edit.icon';
import NewContact from 'assests/icons/new-contact.icon';
import ImportExcelIcon from 'assests/icons/import-excel.icon';

import 'components/GuildePage/guide-page.less';
import 'components/Checkbox/checkbox.less';
import 'components/RoutingTabs/routing-tabs.less';
import RightChevronIcon from 'assests/icons/right-chevron.icon';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import UploadIcon from 'assests/icons/upload.icon';
import SearchIcon from 'assests/icons/search.icon';
import { DimensionsContext } from 'context/dimensions.context';
import { NavLink } from 'react-router-dom';
import * as contactService from 'services/contact.service';
import { ConsoleSqlOutlined } from '@ant-design/icons';
import { customMessages, customValidators } from 'utils';
import { CSVLink } from 'react-csv';
import { useDebouncedCallback } from 'use-debounce/lib';

import { useSelector} from 'react-redux';

const { TabPane } = Tabs;

const GuidePage = () => {
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [newGroupModal, setNewGroupModal] = useState(false);
  const [importFileModal, setImportFileModal] = useState(false);
  const [rowEditModal, setRowEditModal] = useState(false);
  const [addRowModal, setAddRowModal] = useState(false);
  const [changeGroupModal, setChangeGroupModal] = useState(false);
  const [testSelectedRow, setTestSelectedRow] = useState([]);

  const {loading, setLoading} = useSelector(state=>state.loader);
  const [contentName, setContentName] = useState('Genel Grup');
  const [editGroupName, setEditGroupName] = useState(false);

  const [fileList, setFileList] = useState([]);
  const [groupImportFile, setGroupImportFile] = useState(false);
  const [groupName, setGroupName] = useState('Genel Grup');
   const [circles, setCircles] = useState([]);
   
   const [maxCircles, setMaxCircles] = useState(10000);
  const { isPc } = useContext(DimensionsContext);
  const [form] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [selectedCircle, setSelectedCircle] = useState(null);
  
  const [selectedCircleId, setSelectedCircleId] = useState(0);  
  const [contacts, setContacts] = useState([]);

  const [isFileSelected, setIsFileSelected] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  const [searchText, setSearchText] = useState('');
  const [selectedContact, setSelectedContact] = useState(null);

  const headers = [
    {label: 'Telefon Numarası', key: 'msisdn'},
    {label: 'Ad-Soyad', key: 'name'},
    {label: 'E-Posta', key: 'email'}
];

  const columns = [
    {
      title: '',
      dataIndex: 'check',
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  contacts.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setTestSelectedRow(contacts);
                } else {
                  contacts.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setTestSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setTestSelectedRow((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setTestSelectedRow(
                      testSelectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Telefon No',
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'msisdn',
        },
      ],
    },
    {
      title: 'Ad Soyad',
      children: [
        {
          title: () => (
            <div style={{ textAlign: 'right' }}>
              {testSelectedRow.length > 0 ? (
                <span>{testSelectedRow.length} Kişi Seçildi</span>
              ) : null}
            </div>
          ),
          dataIndex: 'name',
        },
      ],
    },
    {
      title: 'E-Posta',
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {testSelectedRow.length > 0 ? (
                <div className="group-actions">
                  <button type="button"    onClick={ () => {onExport();} }>
                    <ExportFileIcon />
                    <span>Dışa aktar</span>
                  </button>
                  <button
                    onClick={() => {
                      setChangeGroupModal(true);
                    }}
                    type="button"
                  >
                    <GroupsIcon />
                    <span>Grupla</span>
                  </button>
                  <button type="button"  title="Grubu Sil"  onClick={()=> onDeleteContact(testSelectedRow.map((item)=> item.id))}>
                    <DeleteIcon />
                    <span>Sil</span>
                  </button>
                </div>
              ) : null}
            </div>
          ),
          dataIndex: 'email',
          render: (text,record) => (
            <>
              <span>{text}</span>
              <div className="row-edit">
                <button
                  onClick={() => {
                    onOpenRowEditModal(record);
                  }}
                  type="button"
                >
                  <EditIcon />
                </button>
                <button type="button" onClick={()=> onDeleteContact([record.id])}>
                  <DeleteIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];
  const mobileColumns = [
    {
      title: '',
      dataIndex: 'check',
      fixed: 'left',
      width: 60,
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  contacts.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setTestSelectedRow(contacts);
                } else {
                  contacts.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setTestSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',

          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setTestSelectedRow((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setTestSelectedRow(
                      testSelectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
          fixed: 'left',
          width: 60,
        },
      ],
    },
    {
      title: 'Telefon No',
      fixed: 'left',
      width: 110,
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'msisdn',
          fixed: 'left',
          width: 110,
        },
      ],
    },
    {
      title: 'Ad Soyad',
      children: [
        {
          title: () => (
            <div style={{ textAlign: 'right' }}>
              {testSelectedRow.length > 0 ? (
                <span>{testSelectedRow.length} Kişi Seçildi</span>
              ) : null}
            </div>
          ),
          dataIndex: 'name',
        },
      ],
    },
    {
      title: 'E-Posta',
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {testSelectedRow.length > 0 ? (
                <div className="group-actions">
                  <button type="button"    onClick={ () => {onExport();} }>
                    <ExportFileIcon />
                    <span>Dışa aktar</span>
                  </button>
                  <button
                    onClick={() => {
                      setChangeGroupModal(true);
                    }}
                    type="button"
                  >
                    <GroupsIcon />
                    <span>Grupla</span>
                  </button>
                  <button type="button" onClick={()=> onDeleteContact( testSelectedRow.map((item)=> item.id))}>
                    <DeleteIcon />
                    <span>Sil</span>
                  </button>
                </div>
              ) : null}
            </div>
          ),
          dataIndex: 'email',
        },
      ],
      render: (text,record) => (
        <>
          <span>{text}</span>
          <div className="row-edit">
            <button
              onClick={() => {
                onOpenRowEditModal(record);
              }}
              type="button"
            >
              <EditIcon />
            </button>
            <button type="button" onClick={()=> onDeleteContact([record.id])}>
              <DeleteIcon />
            </button>
          </div>
        </>
      ),
    },
  ];
  const columnsV2 = [
    {
      title: '',
      dataIndex: 'check',
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  contacts.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setTestSelectedRow(contacts);
                } else {
                  contacts.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setTestSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setTestSelectedRow((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setTestSelectedRow(
                      testSelectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Telefon No',
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'msisdn',
        },
      ],
    },
    {
      title: 'Ad Soyad',
      children: [
        {
          title: '',
          dataIndex: 'name',
        },
      ],
    },
    {
      title: 'E-Posta',
      children: [
        {
          title: () => (
            <div className="table-group-actions table-group-actions--v2">
              {testSelectedRow.length > 0 ? (
                <>
                  <span>{testSelectedRow.length} Kişi Seçildi</span>
                  <div className="group-actions" style={{ width: '105px' }}>
                    <button type="button"  onClick={()=> onDeleteContact( testSelectedRow.map((item)=> item.id))}>
                      <DeleteIcon />
                      <span>Sil</span>
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          ),
          dataIndex: 'email',
          render: (text,record) => (
            <>
              <span>{text}</span>
              <div className="row-edit">
                <button
                  onClick={() => {
                    onOpenRowEditModal(record);
                  }}
                  type="button"
                >
                  <EditIcon />
                </button>
                <button type="button" onClick={()=> onDeleteContact([record.id])}>
                  <DeleteIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];
  const mobileColumnsV2 = [
    {
      title: '',
      dataIndex: 'check',
      fixed: 'left',
      width: 60,
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  contacts.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setTestSelectedRow(contacts);
                } else {
                  contacts.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setTestSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          fixed: 'left',
          width: 60,
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setTestSelectedRow((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setTestSelectedRow(
                      testSelectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Telefon No',
      fixed: 'left',
      width: 110,
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'msisdn',
          fixed: 'left',
          width: 110,
        },
      ],
    },
    {
      title: 'Ad Soyad',
      children: [
        {
          title: '',
          dataIndex: 'name',
        },
      ],
    },
    {
      title: 'E-Posta',
      children: [
        {
          title: () => (
            <div className="table-group-actions table-group-actions--v2">
              {testSelectedRow.length > 0 ? (
                <>
                  <span>{testSelectedRow.length} Kişi Seçildi</span>
                  <div className="group-actions" style={{ width: '105px' }}>
                    <button type="button"   onClick={()=> onDeleteContact(testSelectedRow.map((item)=> item.id))}>
                      <DeleteIcon />
                      <span>Sil</span>
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          ),
          dataIndex: 'email',
          render: (text,record) => (
            <>
              <span>{text}</span>
              <div className="row-edit">
                <button
                  onClick={() => {
                    onOpenRowEditModal(record);
                  }}
                  type="button"
                >
                  <EditIcon />
                </button>
                <button type="button" onClick={()=> onDeleteContact([record.id])}>
                  <DeleteIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];
  
  const selectFileRef = useRef(null);
  const exportRefLink = useRef(null);
  const [filtered, setFiltered] = useState(contacts);

  // const onInputChange = (value) => {
  //   const inputValue = value.toUpperCase();

  //   const filteredArray = contacts.filter((item, index) => {
  //     return (
  //       item.msisdn.toUpperCase().indexOf(inputValue) > -1 ||
  //       item.name.toUpperCase().indexOf(inputValue) > -1 ||
  //       item.email.toUpperCase().indexOf(inputValue) > -1
  //     );
  //   });
  //   setFiltered(filteredArray);
  // };

  function fetchCircle(setSelected) {
    contactService.getCircles()
      .then((result) => {
        setCircles(result.circle);
        setMaxCircles(result.maxCircleCount);
        if (setSelected)
        {
          const circle=result.circle.filter(c => c.name == 'Genel Grup')[0];
          setSelectedCircle(circle);
          setSelectedCircleId(circle.id);
          setContentName('Genel Grup');
          setGroupName('Genel Grup');
          //fetchCircleContacts(circle.id);
        }
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }
  
  function onUpdateContact(contact)
   { 
     contact.circle={id:selectedCircleId};
     contact.id=selectedContact.id;
    
     contactService.updateContact(contact)
       .then((result) => {       
         fetchCircleContacts(selectedCircleId);
         setSelectedContact(null);
         form.resetFields();
         setRowEditModal(false);       
         setTestSelectedRow([]);
       }).catch((response) => {
         message.error(customMessages.getMessage(response.responseCode));
       });
   }

  function fetchCircleContacts(id,text =searchText) {
    console.log("id:" + id + ", text : " +text);
    contactService.getCircleContacts(id,text)
      .then((result) => {
        setContacts(result.contacts);
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  function onCreateContact(values)
  {
    const filtered = contacts.filter((item, index) => {
          return (
            item.msisdn==values.msisdn
          );
        });
    if (filtered.length>0)
    {
      message.error(customMessages.getMessage("CONTACT-DUB"));
      return;
    }
    values.circle={id:selectedCircleId};
    contactService.addContact(values)
      .then((result) => {
        fetchCircleContacts(selectedCircleId);
        setAddRowModal(false);
        setTestSelectedRow([]);
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }


  function onDeleteContact(ids) {
    contactService.removeContacts(selectedCircleId,{ids:ids})
      .then((result) => {
        fetchCircleContacts(selectedCircleId);
        setTestSelectedRow([]);
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }


  function createCircle(data) {
    contactService.addCircle(data)
      .then((result) => {
        fetchCircle(false);
        
        form.resetFields();
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  function addContactsToCircle() {
    if (!uploadedFile)
    {
      Modal.error({
        title: 'Hata',
        content: 'Dosya yükleyiniz!',
      });
      return;
    }
    contactService.addContactsFromFile(selectedCircle.id, uploadedFile).then((res) => {
      setImportFileModal(false);
      setContentName(selectedCircle.name);
      fetchCircleContacts(selectedCircle.id);
      setUploadedFile(null);
      form.resetFields();
    })
    .catch((response) => {
      form.resetFields();
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  }



  function onOpenRowEditModal (record) {
    formEdit.resetFields();
    setSelectedContact(record); 
    setRowEditModal(true);   
  }

  function onCloseNewGroupModal () {
    setNewGroupModal(false);
    setSelectedContact(null);
    form.resetFields();
  }

  function onCloseRowEditModal () {
    formEdit.resetFields();
    setSelectedContact(null);
    setRowEditModal(false);
  }

  function onCloseFileUploadModal () {
    setImportFileModal(false);
    setIsFileSelected(false);
    setUploadedFile(null);
    form.resetFields();

  }

  const onFileUpload = (e) => { 
    const file= e.target.files[0];
    if (file)
    {
    setIsFileSelected(true);
    setUploadedFile(file);
    }
   }

   const onGroupFilter = useDebouncedCallback(
    // function
    (e) => {
     
      fetchCircleContacts(selectedCircle.id,e);
    },
    // delay in ms
    700
  );
  
  function onDeleteCircle(id) {
    contactService.deleteCircle(id)
      .then((result) => {
        fetchCircle(true);
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

    
  function onUpdateCircle(values) {
    selectedCircle.name=values.editGroupName;
    contactService.updateCircle({name:selectedCircle.name,id:selectedCircleId})
      .then((result) => {
       setSelectedCircle(selectedCircle);
       setEditGroupName(false);
       setGroupName(values.editGroupName);
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }



 


  useEffect(() => {
    if (!rowEditModal)
    {
      setSelectedContact(null);
      formEdit.resetFields();
    }
  }, [rowEditModal]);

  
  useEffect(() => {
    fetchCircle(true);
  }, []);


  useEffect(() => {
    if (selectedCircleId>0)
    {
      var circle = circles.filter((item, index) => {
        return selectedCircleId == item.id;
      })[0];
      if (circle)
      {
        setGroupName(circle.name);
        setContentName(circle.name);
        setSelectedCircle(circle);
        setSearchText('');
      }
      fetchCircleContacts(selectedCircleId);
    }
  }, [selectedCircleId]);


  function onExport ()
   {
   exportRefLink.current.link.click();
     
   }
  
  useEffect(() => {
    form.resetFields();
  }, [addRowModal]);

    
  return (
    <Layout>
      <div className="routing">
        <NavLink to="/Messages" activeClassName="active">
          <span>Mesaj Gönder</span>
        </NavLink>
        <NavLink to="/Guide" activeClassName="active">
          <span>Rehberim</span>
        </NavLink>
        <NavLink to="/BlackList" activeClassName="active">
          <span>Kara Liste</span>
        </NavLink>
      </div>
      <div className="messages-page messages-tab">
        <div className="container">
          <h1 className="section__title">Rehberim</h1>
          <div className="box">
            <div className="group-titles">
              <div className="sub-groups">
                <ul>
                  {circles.map((circle) => (
                    <li
                      key={circle.id}
                      className={classNames({
                        active: contentName === circle.name,
                      })}
                      onClick={() => {
                        
                        setSelectedCircleId(circle.id);
                      }}
                    >
                      <span>{circle.name}</span>
                      <RightChevronIcon />
                    </li>
                  ))}
                </ul>
              </div>
              <div className="new-group">
                <CSVLink
                  data={contacts}
                  headers={headers}
                  ref={exportRefLink}
                  filename={groupName + ' - kişiler.xls'}
                  separator={';'}
                  target="_blank"
                >
                  {' '}
                </CSVLink>
                <Button
                  shape="round"
                  type="ghost"
                  onClick={() => {
                    setNewGroupModal(true);
                  }}
                >
                  <GroupsIcon />
                  Yeni Grup
                </Button>
                <Modal
                  title="Yeni Grup Oluştur"
                  visible={newGroupModal}
                  onCancel={() => setNewGroupModal(false)}
                  footer={null}
                >
                  <Form form={form} name="newGroup">
                    <Form.Item
                      name="newGroupName"
                      messageVariables={{ label: 'Grup Adı' }}
                      className="margin-bottom-0"
                    >
                      <Input type="text" name="newGroupName" label="Grup Adı" />
                    </Form.Item>
                    <div className="modal-action">
                      <Button
                        shape="round"
                        type="ghost"
                        onClick={() => onCloseNewGroupModal()}
                      >
                        Vazgeç
                      </Button>
                      <Button
                        key="confirm"
                        type="primary"
                        onClick={() => {
                          createCircle({
                            name: form.getFieldValue('newGroupName'),
                          });
                          setNewGroupModal(false);
                        }}
                      >
                        Kaydet
                      </Button>
                    </div>
                  </Form>
                </Modal>
              </div>
            </div>
            {selectedCircleId > 0 && (
              <Tabs
                defaultActiveKey={selectedCircleId}
                onChange={(item) => {
                  setSelectedCircleId(item);
                }}
                renderTabBar={(props, Item) => {
                  return <MobileTabBar props={props} item={Item} />;
                }}
              >
                {circles.map((circle) => (
                  <TabPane tab={circle.name} key={circle.id}></TabPane>
                ))}
              </Tabs>
            )}
            {contentName === 'Genel Grup' ? (
              <div className="group-members">
                <div className="group-members__header">
                  <strong className="group-members__title">
                    {groupName}
                    <span></span>
                  </strong>
                  <div className="group-actions">
                    <button
                      onClick={() => {
                        setAddRowModal(true);
                      }}
                      type="button"
                    >
                      <NewContact />
                      <span>Yeni Kişi</span>
                    </button>
                    <button
                      onClick={() => {
                        onExport();
                      }}
                      type="button"
                    >
                      <ExportFileIcon />
                      <span>Dışa aktar</span>
                    </button>
                    <div>
                      <input
                        type="file"
                        ref={selectFileRef}
                        onChange={(e) => {
                          setFileList(e.target.files);
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => setImportFileModal(true)}
                      >
                        <ImportExcelIcon />
                        İçe Aktar
                        <DownChevronIcon />
                      </button>
                      
                    </div>
                  </div>
                </div>
                <div className="group-members__search">
                  <Input
                    prefix={<SearchIcon />}
                    placeholder="Grup İçerisinde Ara..."
                    autoComplete="off"
                    value={searchText}
                    style={{ width: '100%' }}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      onGroupFilter(e.target.value);
                    }}
                  />
                </div> 
                {circles.length>maxCircles &&

                
                <InfoBox
                type="warning"
                content={
                  <p>
                    <strong>En fazla {maxCircles} adet</strong> grup yaratılmasına izin verilmektedir. 
                    Kullanmadığınız grupların silinmesi veya grupları birleştirilmesini öneririz..
                  </p>
                }
              />}
                 <Table
                    rowKey="id"
                    columns={isPc ? columnsV2 : mobileColumnsV2}
                    scroll={isPc ? { y: 610 } : { y: 610, x: 700 }}
                    dataSource={contacts}
                    className="table--guide"
                    pagination={{
                      total: contacts.length,
                      position: ['bottomCenter'],
                    }}
                  />
              </div>
            ) : (
              <div className="group-members">
                <div className="group-members__header">
                  <strong className="group-members__title">
                    {groupName}{' '}
                    <button
                      onClick={() => setEditGroupName(true)}
                      type="button"
                    >
                      <EditIcon />
                    </button>
                  </strong>
                  <div className="group-actions group-actions--v2">
                    <button
                      onClick={() => {
                        setAddRowModal(true);
                      }}
                      type="button"
                    >
                      <NewContact />
                    </button>
                    <button
                      onClick={() => {
                        onExport();
                      }}
                      type="button"
                    >
                      <ExportFileIcon />
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setImportFileModal(true);
                      }}
                    >
                      <ImportExcelIcon />
                    </button>
                    <button
                      title="Grubu Sil"
                      onClick={() => {
                        onDeleteCircle(selectedCircleId);
                      }}
                      type="button"
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                </div>
                <div className="group-members__search">
                  <Input
                    prefix={<SearchIcon />}
                    placeholder="Grup İçerisinde Ara..."
                    autoComplete="off"
                    value={searchText}
                    style={{ width: '100%' }}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      onGroupFilter(e.target.value);
                    }}
                  />
                </div>
                {circles.length>maxCircles &&
                  <InfoBox
                  type="warning"
                  content={
                    <p>
                      <strong>En fazla {maxCircles} adet</strong> grup yaratılmasına izin verilmektedir. 
                      Kullanmadığınız grupların silinmesi veya grupları birleştirilmesini öneririz..
                    </p>
                  }
                  />}
               
                  <Table
                    rowKey="id"
                    columns={isPc ? columnsV2 : mobileColumnsV2}
                    scroll={isPc ? { y: 610 } : { y: 610, x: 700 }}
                    dataSource={contacts}
                    className="table--guide"
                    pagination={{
                      total: contacts.length,
                      position: ['bottomCenter'],
                    }}
                  />

                <Modal
                  title="Grup Adını Değiştir"
                  visible={editGroupName}
                  onCancel={() => setEditGroupName(false)}
                  footer={null}
                >
                  <Form form={form} name="editCircle" onFinish={onUpdateCircle}>
                    <Form.Item
                      initialValue={selectedCircle.name}
                      name="editGroupName"
                      messageVariables={{ label: 'Grup Adı' }}
                      className="margin-bottom-0"
                    >
                      <Input
                        type="text"
                        name="editGroupName"
                        label="Grup Adı"
                      />
                    </Form.Item>
                    <div className="modal-action">
                      <Button
                        shape="round"
                        type="ghost"
                        onClick={() => setEditGroupName(false)}
                      >
                        Vazgeç
                      </Button>
                      <Button key="confirm" type="primary" htmlType="submit">
                        Kaydet
                      </Button>
                    </div>
                  </Form>
                </Modal>
              </div>
            )}
            {rowEditModal && (
              <Modal
                title="Kişiyi Düzenle"
                visible={rowEditModal}
                destroyOnClose={true}
                onCancel={() => setRowEditModal(false)}
                footer={null}
              >
                <Form
                  form={formEdit}
                  name="edit-row"
                  onFinish={onUpdateContact}
                >
                  <Form.Item
                    name="msisdn"
                    initialValue={selectedContact ? selectedContact.msisdn : ''}
                    rules={[
                      {
                        validator: customValidators.isMsisdn,
                      },
                    ]}
                    messageVariables={{ label: 'number' }}
                    getValueFromEvent={(e) => {
                      const convertedValue = Number(e.target.value);
                      if (isNaN(convertedValue)) {
                        return '';
                      } else {
                        return convertedValue;
                      }
                    }}
                  >
                    <Input
                      maxLength={10}
                      type="tel"
                      name="msisdn"
                      label="Telefon Numarası"
                    />
                  </Form.Item>
                  <Form.Item
                    name="name"
                    initialValue={selectedContact ? selectedContact.name : ''}
                    messageVariables={{ label: 'name' }}
                  >
                    <Input type="text" name="edit-name" label="Kişi Adı" />
                  </Form.Item>
                  <Form.Item
                    name="email"
                    initialValue={selectedContact ? selectedContact.email : ''}
                    messageVariables={{ label: 'e-mail' }}
                  >
                    <Input
                      type="mail"
                      name="edit-row-mail"
                      label="E-Posta Adresi"
                    />
                  </Form.Item>
                  <div className="modal-action">
                    <Button
                      shape="round"
                      type="ghost"
                      onClick={() => onCloseRowEditModal()}
                    >
                      Vazgeç
                    </Button>
                    <Button
                      key="confirm"
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                    >
                      Kaydet
                    </Button>
                  </div>
                </Form>
              </Modal>
            )}
            <Modal
              title="Kişi Ekle"
              visible={addRowModal}
              onCancel={() => setAddRowModal(false)}
              footer={null}
            >
              <Form form={form} name="add-row" onFinish={onCreateContact}>
                <Form.Item
                  name="msisdn"
                  messageVariables={{ label: 'number' }}
                  rules={[
                    {
                      len: 10,
                      validator: customValidators.isMsisdn,
                    },
                  ]}
                  getValueFromEvent={(e) => {
                    const convertedValue = Number(e.target.value);
                    if (isNaN(convertedValue)) {
                      return '';
                    } else {
                      return convertedValue;
                    }
                  }}
                >
                  <Input
                    type="tel"
                    required="true"
                    name="msisdn"
                    maxLength="10"
                    label="Telefon Numarası"
                  />
                </Form.Item>
                <Form.Item name="name" messageVariables={{ label: 'name' }}>
                  <Input type="text" name="name" label="Kişi Adı" />
                </Form.Item>
                <Form.Item name="email" messageVariables={{ label: 'email' }}>
                  <Input type="mail" name="email" label="E-Posta Adresi" />
                </Form.Item>
                <div className="modal-action">
                  <Button
                    shape="round"
                    type="ghost"
                    onClick={() => setAddRowModal(false)}
                  >
                    Vazgeç
                  </Button>
                  <Button key="confirm" type="primary" htmlType="submit">
                    Kaydet
                  </Button>
                </div>
              </Form>
            </Modal>

            <Modal
              title="Dosyayı İçeri Aktar"
              visible={importFileModal}
              onCancel={() => setImportFileModal(false)}
              footer={null}
            >
              <Form form={form} name="import-file">
                <Form.Item
                  name="select-file"
                  messageVariables={{ label: 'file' }}
                >
                  <SelectFile
                    onChange={onFileUpload}
                    uploaderRef={selectFileRef}
                    type="file"
                    allowExtensions={['xlsx', 'xls', 'txt', 'zip', 'vcard']}
                    fileList={fileList}
                    title={<span>Excel'den İçe Aktar</span>}
                    icon={<UploadIcon />}
                  />
                </Form.Item>
                <span>
                  Rehber kayıtlarınızı oluşturabileceğiniz örnek Excel dosyasını
                  indirmek için{' '}
                  <a href="/samples/ornek.xlsx" download>
                    tıklayın.
                  </a>
                </span>
                <div className="modal-action">
                  <Button
                    shape="round"
                    type="ghost"
                    onClick={() => {
                      onCloseFileUploadModal();
                    }}
                  >
                    Vazgeç
                  </Button>
                  <Button
                    disabled={!isFileSelected}
                    key="confirm"
                    type="primary"
                    onClick={() => addContactsToCircle()}
                  >
                    Kaydet
                  </Button>
                </div>
              </Form>
            </Modal>
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default GuidePage;
